import ApiClient from "./apiClient";
import { QueriesApi } from "./apiTypes";



const apiAccessService = {

  getApiTokens:(queries:any) => ApiClient.get(`api-tokens?page_size=${queries.pageSize}&page=${queries.page}`),
  createApiToken:(data:any) => ApiClient.post(`api-tokens`, data),
  revokeApiToken:(id:string|number) => ApiClient.delete(`api-tokens/${id}`),


  getOpenstackTokens:(queries:any) => ApiClient.get(`app-tokens?page_size=${queries.pageSize}&page=${queries.page}`),
  createOpenstackToken:(data:any) => ApiClient.post(`app-tokens`, data),
  revokeOpenstackToken:(id:string|number) => ApiClient.delete(`app-tokens/${id}`),
  downloadYaml:(id:string|number) => ApiClient.get(`app-tokens/${id}/download_yaml`),
  downloadOpenrc:(id:string|number) => ApiClient.get(`app-tokens/${id}/download_openrc`),


  getS3Token:(queries:any) => ApiClient.get(`object-storage/tokens?page_size=${queries.pageSize}&page=${queries.page}`),
  createS3Token:(data:any) => ApiClient.post(`object-storage/tokens`, data),
  revokeS3Token:(accessKey:string|number) => ApiClient.delete(`object-storage/tokens/${accessKey}`),
}

export default apiAccessService
